import { gql } from '@apollo/client/core';
import { richTextBlockFragment } from './rich-text-block.fragment';

export const accordionBlockFragment = gql`
  fragment AccordionItemFields on AccordionItem {
    entryTitle
    title
    content {
      ...RichTextBlockFields
    }
  }

  fragment AccordionBlockFields on AccordionBlock {
    entryTitle
    accordionTitle
    description
    accordionItemsCollection(limit: 20) {
      items {
        ...AccordionItemFields
      }
    }
  }
  ${richTextBlockFragment}
`;
